import { Dashed, Divider, Title, ListItem, ListItemText } from "./styles";
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import {
    Collapse,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    List,
    Divider as MuiDivider,
} from "@mui/material";
import { useEffect, useState } from "react";

import { Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DialogApproveById from "./dialogApproveById";
import IconButton from "@mui/material/IconButton";
import { ExpandLess, ExpandMore } from "@mui/icons-material";

export interface IDialogProps {
    open: boolean;
    onClose?: any;
    data?: any;
    clearDataTable: () => void;
}

export default function DialogCalculatedValues({ open, onClose, data, clearDataTable }: IDialogProps) {
    const { faturaInstalacaoID, numeroInstalacao, nomeUsina } = data;
    const valuesToApprove = { faturaInstalacaoID, numeroInstalacao, nomeUsina };
    const [approveById, setApproveById] = useState(false);
    const [valueId, setValueId] = useState<any>();
    const [valueTotalLancamento, setValuetotalLancamento] = useState("0,00");
    var formato = { minimumFractionDigits: 2, style: "currency", currency: "BRL" };
    const [openItem, setOpenItem] = useState(false);

    const handleClick = () => {
        setOpenItem(!openItem);
    };

    const handleApproveById = (valuesToApprove: any) => {
        setApproveById(true);
        setValueId({
            id: valuesToApprove.faturaInstalacaoID,
            numeroInstalacao: valuesToApprove.numeroInstalacao,
            nomeUsina: valuesToApprove.nomeUsina,
        });
    };

    useEffect(() => {
        if (data) {
            if (data.acrescimoDinheiro === undefined && data.bonificacaoDinheiro === undefined) {
                setValuetotalLancamento("0,00");
            } else {
                let valorTotalLancamentos =
                    +data.acrescimoDinheiro.replaceAll(".", "").replaceAll(",", ".") +
                    +data.bonificacaoDinheiro.replaceAll(".", "").replaceAll(",", ".");

                setValuetotalLancamento(valorTotalLancamentos.toLocaleString("pt-BR", formato));
            }
        }
    }, [data]);

    return (
        <div>
            <Dialog
                maxWidth="md"
                fullWidth
                onClose={(_, reason) => {
                    if (reason !== "backdropClick") {
                        onClose();
                    }
                }}
                open={open}
            >
                <DialogTitle>
                    <Title>Valores calculados</Title>
                    <IconButton
                        aria-label="close"
                        onClick={onClose}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                            // color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers>
                    <Divider>
                        <div className="subTitle">Descrição</div>
                        <div className="subTitle">Valor</div>
                    </Divider>
                    <Dashed />
                    <List
                        sx={{ width: "100%", bgcolor: "background.paper" }}
                        component="nav"
                        aria-labelledby="nested-list-subheader"
                    >
                        <ListItem divider>
                            <ListItemText primary="Instalação" />
                            {data.numeroInstalacao}
                        </ListItem>
                        <ListItem divider>
                            <ListItemText primary="Usina" />
                            {data.nomeUsina}
                        </ListItem>
                        <ListItem divider>
                            <ListItemText primary="Cota contratada" />
                            {data.cotaKWH}
                        </ListItem>
                        <ListItem divider>
                            <ListItemText primary="Energia injetada" />
                            {data.energiaInjetada}
                        </ListItem>
                        <ListItem divider>
                            <ListItemText primary="Energia prevista" />
                            {data.energiaPrevista}
                        </ListItem>
                        <ListItem divider>
                            <ListItemText primary="Consumo" />
                            {data.consumo}
                        </ListItem>
                        <ListItem divider>
                            <ListItemText primary="Disponibilidade" />
                            {data.disponibilidadeKWH}
                        </ListItem>
                        <ListItem divider>
                            <ListItemText primary="Saldo consolidado anterior" />
                            {data.saldoConsolidadoAnterior}
                        </ListItem>
                        <ListItem divider>
                            <ListItemText primary="Saldo consolidado atual" />
                            {data.saldoConsolidadoAtual}
                        </ListItem>
                        <ListItem divider>
                            <ListItemText primary="Diferença saldo consolidado" />
                            {data.saldoConsolidadoDiferenca}
                        </ListItem>
                        <ListItem divider>
                            <ListItemText primary="Saldo não pago anterior" />
                            {data.saldoAlsolAnterior}
                        </ListItem>
                        <ListItem divider>
                            <ListItemText primary="Saldo não pago atual" />
                            {data.saldoAlsolAtual}
                        </ListItem>
                        <ListItem divider>
                            <ListItemText primary="Diferença saldo não pago" />
                            {data.saldoAlsolDiferenca}
                        </ListItem>
                        <ListItem divider>
                            <ListItemText primary="Saldo concessionária anterior" />
                            {data.saldoConcessionariaAnterior}
                        </ListItem>
                        <ListItem divider>
                            <ListItemText primary="Saldo concessionária atual" />
                            {data.saldoConcessionariaAtual}
                        </ListItem>
                        <ListItem divider>
                            <ListItemText primary="Diferença saldo concessionária" />
                            {data.saldoConcessionariaDiferenca}
                        </ListItem>
                        <ListItem divider>
                            <ListItemText primary="Saldo outros anterior" />
                            {data.saldoOutrosAnterior}
                        </ListItem>
                        <ListItem divider>
                            <ListItemText primary="Saldo outros atual" />
                            {data.saldoOutrosAtual}
                        </ListItem>
                        <ListItem divider>
                            <ListItemText primary="Diferença saldo outros" />
                            {data.saldoOutrosDiferenca}
                        </ListItem>
                        <ListItem divider>
                            <ListItemText primary="Tarifa concessionária" />
                            R$ {data.tarifaConcessionaria}
                        </ListItem>
                        <ListItem divider>
                            <ListItemText primary="Tarifa concessionária utilizada" />
                            R$ {data.tarifaConcessionariaUtilizada === "" ? "0,00" : data.tarifaConcessionariaUtilizada}
                        </ListItem>
                        <ListItem onClick={handleClick} cursor={"pointer"}>
                            <ListItemText primary="Descontos" />
                            {openItem ? <ExpandLess /> : <ExpandMore />}
                        </ListItem>
                        <Collapse in={openItem} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding sx={{ cursor: "default" }}>
                                <ListItem sx={{ pl: 4 }}>
                                    <ListItemText primary="Desconto contratado" />
                                    {data.descontoContratado}%
                                </ListItem>
                                <ListItem sx={{ pl: 4 }}>
                                    <ListItemText primary="Desconto faturamento" />
                                    {data?.descontoFaturado?.length === 0 ? "0,00" : data.descontoFaturado}%
                                </ListItem>
                            </List>
                        </Collapse>
                        <MuiDivider />
                        <ListItem divider>
                            <ListItemText primary="Tarifa cobrada" />
                            R$ {data.tarifaCobrada}
                        </ListItem>
                        <ListItem divider>
                            <ListItemText primary="Créditos faturados" />
                            {data.creditosFaturados}
                        </ListItem>
                        <ListItem divider>
                            <ListItemText primary="Valor da fatura" />
                            R$ {data.valorFatura}
                        </ListItem>
                        <ListItem divider>
                            <ListItemText primary="Regra" />
                            {data.regraFatura}
                        </ListItem>
                        <ListItem divider>
                            <ListItemText primary="Percentual de diferença" />
                            {data.percentualDiferenca}%
                        </ListItem>
                        <ListItem divider>
                            <ListItemText primary="Valor total de lançamentos" />
                            {valueTotalLancamento}
                        </ListItem>
                        <ListItem divider>
                            <ListItemText primary="Conferência" />
                            {data.confDispoConsumo}
                        </ListItem>
                    </List>
                </DialogContent>
                <DialogActions style={{ display: "flex", justifyContent: "center", margin: "24px" }}>
                    <Button
                        onClick={onClose}
                        color="warning"
                        variant="contained"
                        style={{ width: "159px", height: "44px" }}
                    >
                        Cancelar
                    </Button>
                    <Button
                        onClick={() => handleApproveById(valuesToApprove)}
                        disabled={data.statusFaturaInstalacao !== "Aberta"}
                        variant="contained"
                        style={{ width: "159px", height: "44px" }}
                    >
                        Aprovar
                    </Button>
                </DialogActions>
            </Dialog>

            <DialogApproveById
                open={approveById}
                idProp={valueId}
                clearDataTable={clearDataTable}
                closeParentModal={onClose}
                onClose={() => setApproveById(false)}
            />
        </div>
    );
}
